import { useQuery } from '@apollo/client';
import { Nullable } from 'global';
import { dealBuilderApi, CustomerContactItem, CustomerContactsQueryResponse } from '../api';

interface UseCustomerContactsResult {
  contacts: CustomerContactItem[];
  loading: boolean;
}

export const useCustomerContacts = (customerAccountId: Nullable<string>): UseCustomerContactsResult => {
  const { data, loading } = useQuery<CustomerContactsQueryResponse>(dealBuilderApi.getCustomerContacts, {
    variables: { customerAccountId },
    skip: !customerAccountId,
    fetchPolicy: 'cache-and-network',
  });

  return {
    contacts: data?.customer?.customerContacts?.list ?? [],
    loading,
  };
};
